import React from 'react';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import EditableLable from '../../../../common/labels/EditableLabel/EditableLable';
import TableBasicLabel from '../../../../common/labels/TableBasicLabel/TableBasicLabel';
import { getHoursAndMinutes, getNumberWithDelimeter, isValidByRateType } from '../../../../../utils/helpers';
// import { getHoursByDate } from '../helpers';
import colors from '../../../../../scss/colors';
import { rateEnum, submissionEnum } from '../../../../../utils/enums';
import OutlinedCheckBox from '../../../../common/Form/OutlinedCheckBox/OutlinedCheckBox';
import { getTotals } from '../../helpers';

const styleConfigMonthly = {
    straighttime: { width: { min: '138px', max: '160px' } },
    overtime: { width: { min: '100px', max: '120px' } },
    pto: { width: { min: '80px', max: '90px' } },
    date: { width: { min: '64px', max: '64px' } },
    total: { width: { min: '138px', max: '160px' } }
};

const basicFontSize = '14px';

const forcedBrakeWidth = '25px';

const FooterCell = styled('div')(({ radius = '0', extrastyles = {} }) => ({
    width: '100%',
    height: '100%',
    paddingTop: '8px',
    paddingBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radius,
    ...extrastyles
}));

const fixJSfailWithMath = (num) => {
    if (num % 1 === 0) return num;
    return num?.toFixed(2);
};

const total1stColumn = (
    t,
    data,
    rateType,
    workTypes
) => {
    const totals = getTotals(data);
    return [
        {
            id: '2',
            name: () => (
                <TableBasicLabel
                    text={t('dashboard.timesheet.table.straighttime')}
                    fontColor="white"
                    textAlign="left"
                    padding="0 0 0 15px"
                />
            ),
            width: styleConfigMonthly.straighttime.width,
            value: (data) => {
                const value = totals[workTypes?.find((x) => x.key === 1)?.label]
                return (
                    <>
                        {rateType === 'hourly' ?
                            getHoursAndMinutes(value)
                            :
                            `${parseFloat(value.toFixed(2).toString())} day${parseFloat(value.toFixed(2).toString()) > 1 ? 's' : ''}`}
                    </>
                )

            }
        },
        {
            id: '3',
            name: () => (
                <TableBasicLabel
                    text={t('dashboard.timesheet.table.overtime')}
                    fontColor="white"
                    textAlign="left"
                    padding="0 0 0 8px"
                />
            ),
            width: styleConfigMonthly.overtime.width,
            value: (data) => {
                const value = totals[workTypes?.find((x) => x.key === 2)?.label]
                return (
                    <>
                        {rateType === 'hourly' ?
                            getHoursAndMinutes(value)
                            :
                            `${parseFloat(value.toFixed(2).toString())} day${parseFloat(value.toFixed(2).toString()) > 1 ? 's' : ''}`}
                    </>
                )

            }
        },
        {
            id: 'code',
            name: () => (
                <TableBasicLabel
                    text={t('dashboard.timesheet.table.pto')}
                    fontColor="white"
                    textAlign="left"
                    padding="0 0 0 20px"
                />
            ),
            width: styleConfigMonthly.pto.width,
            value: (data) => {
                const value = totals[workTypes?.find((x) => x.key === 5)?.label]
                return (
                    <>
                        {rateType === 'hourly' ?
                            getHoursAndMinutes(value)
                            :
                            `${parseFloat(value.toFixed(2).toString())} day${parseFloat(value.toFixed(2).toString()) > 1 ? 's' : ''}`}
                    </>
                )

            }
        },
    ];
};

const total2ndColumn = (
    fullData
) => {
    const firstDate = fullData?.[0]?.TimesheetHoursByDates?.[0]?.Day;
    const mergedData = fullData.reduce((acc, entry) => {
        entry.TimesheetHoursByDates.forEach(({ Day, TotalHrs }) => {
            if (!acc[Day]) {
                acc[Day] = 0;
            }
            acc[Day] += TotalHrs;
        });
        return acc;
    }, {});
    const sortedDates = Object.keys(mergedData).sort();
    return sortedDates?.map((date, index) => {
        const currentDate = dayjs(firstDate).add(index, 'day');
        return {
            id: 4 + index,
            width: styleConfigMonthly.date.width,
            name: () => (
                <div className="d-flex flex-column">
                    <TableBasicLabel
                        withForceBrake={forcedBrakeWidth}
                        text={dayjs(dayjs(firstDate).add(index, 'day')).format('ddd')}
                        fontColor="white"
                        fontSize="14px"
                        fontWeight="400"
                        lineHeight="17px"
                    />
                    <TableBasicLabel
                        withForceBrake={forcedBrakeWidth}
                        text={dayjs(dayjs(firstDate).add(index, 'day')).format('DD')}
                        fontColor="white"
                        notNumber
                    />
                </div>
            ),
            value: (data) => (
                <FooterCell
                    radius="10px"
                    extrastyles={
                        dayjs(firstDate).add(index, 'day').day() === 6 || dayjs(firstDate).add(index, 'day').day() === 0
                            ? {
                                backgroundColor: colors.PAGE_BACKGROUND,
                                marginLeft: '8px',
                                marginRight: '8px',
                                paddingTop: '16px',
                                paddingBottom: '16px'
                            }
                            : {}
                    }
                >
                    <TableBasicLabel
                        text={mergedData[date] ? getNumberWithDelimeter(fixJSfailWithMath(mergedData[date])) : '0'}
                        fontSize={basicFontSize}
                        isEdit={false}
                    />
                </FooterCell>
            ),
        };
    });
};

const total3rdColumn = (
    t,
    data,
    workTypes,
    rateType
) => {
    const totals = getTotals(data);
    return [
        {
            id: '11',
            width: styleConfigMonthly.total.width,
            name: () => <TableBasicLabel text={t('dashboard.timesheet.table.totalTime')} fontColor="white" />,
            value: (data) => {
                const value = totals['Total Time']
                return (
                    <>
                        {rateType === 'hourly' ?
                            <TableBasicLabel
                                text={getHoursAndMinutes(value)}
                                fontSize={basicFontSize}
                                isEdit={false}
                            />
                            :
                            <TableBasicLabel
                                text={`${parseFloat(value.toFixed(2).toString())} day${parseFloat(value.toFixed(2).toString()) > 1 ? 's' : ''}`}
                                fontSize={basicFontSize}
                                isEdit={false}
                            />
                        }

                    </>
                )

            }
        }
    ];
};

export { total1stColumn, total2ndColumn, total3rdColumn };
